import React from 'react';
import { searchPageStyles } from './SearchPage.styles';

const BlockedMessage = ({ blockedMessage }) => {
  if (!blockedMessage) return null;

  return (
    <div style={searchPageStyles.blockedMessage}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: '8px', 
        marginBottom: '8px' 
      }}>
        <span style={{ fontSize: '16px' }}>🚫</span>
        <strong>Search Blocked</strong>
      </div>
      <p style={{ margin: '0', fontSize: '13px', opacity: 0.9 }}>
        This search term is not allowed: &quot;{blockedMessage}&quot;. Try a different query or ask an adult for help.
      </p>
    </div>
  );
};

export default BlockedMessage; 